<div class="statistics__card">
  <div class="statistics__card__header d-flex align-items-center">
    <div class="statistics__card__icon">
      <span [innerHTML]="statsSVG"></span>
    </div>
    <p class="cursor-pointer" routerLink="/dashboard">
      <ng-content></ng-content>
    </p>
  </div>
  <div class="statistics__card__body">
    <div class="row">
      <ng-container [ngSwitch]="statsType">
        <ng-container *ngSwitchCase="'services'">
          <!-- <div class="col-6">
            <p class="stats__label">{{ "stats.bill-payment" | translate }}</p>
            <h4
              class="stats__value mb-0"
              app-animating-count
              [count]="+allStatistics.billServiceCount"
              [skips]="200"
              [interval]="40"
            ></h4>
          </div> -->

          <!-- <div class="col-6">
            <p class="stats__label">
              {{ "stats.total" | translate }}
            </p>
            <h4
              class="stats__value mb-0"
              app-animating-count
              [count]="+allStatistics.otherServices!"
              [skips]="20"
              [interval]="40"
            ></h4>
          </div> -->
          <div class="col-6">
            <p class="stats__label">{{ "stats.central" | translate }}</p>
            <h4
              class="stats__value mb-0"
              app-animating-count
              [count]="+allStatistics?.centerServiceCount"
              [skips]="15"
              [interval]="40"
              [yOffset]="-200"
            ></h4>
          </div>

          <div class="col-6">
            <p class="stats__label">{{ "stats.state" | translate }}</p>
            <h4
              class="stats__value mb-0"
              app-animating-count
              [count]="+allStatistics?.stateServiceCount"
              [skips]="15"
              [interval]="40"
              [yOffset]="-200"
            ></h4>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'departments'">
          <div class="col-6">
            <p class="stats__label">{{ "stats.central" | translate }}</p>
            <h4
              class="stats__value mb-0"
              app-animating-count
              [count]="+allStatistics?.centerDeptCount"
              [skips]="5"
              [interval]="40"
              [yOffset]="-200"
            ></h4>
          </div>

          <div class="col-6">
            <p class="stats__label">{{ "stats.state" | translate }}</p>
            <h4
              class="stats__value mb-0"
              app-animating-count
              [count]="+allStatistics?.stateDeptCount"
              [skips]="5"
              [interval]="40"
            ></h4>
          </div>
        </ng-container>

        <div *ngSwitchCase="'registrations'" class="col-12">
          <p class="stats__label">{{ "stats.total" | translate }}</p>
          <h4 class="stats__value mb-0">
            <span
              app-animating-count
              [count]="+allStatistics?.totalRegisteredUser"
              [skips]="1000000"
              [interval]="40"
              [yOffset]="-200"
              [enableINRformat]="true"
              [registrationConvertToCrore]="true"
            ></span>
          </h4>
        </div>

        <div *ngSwitchCase="'transactions'" class="col-12">
          <p class="stats__label">{{ "stats.total" | translate }}</p>
          <h4 class="stats__value mb-0">
            <span
              app-animating-count
              [count]="+allStatistics?.totalTransactionCount"
              [skips]="50000000"
              [interval]="40"
              [enableINRformat]="true"
              [yOffset]="-200"
            >
            </span>
          </h4>
        </div>
      </ng-container>
    </div>
  </div>
</div>
